import React, { Component } from 'react';


export class Loading extends Component {
    render() {
        return (
            <div className="comp_loading">
                <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                    <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
                </svg>
            </div>
        )
    }
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/standard/loading/Loading.jsx